export const SET_TOKEN = 'yoga-adm/user/set-token';
export const LOGOUT = 'yoga-adm/user/logout';
